import {Container} from 'substance'

class BodyNode extends Container {}

BodyNode.type = 'body'

export {BodyNode}
